export const isVoiceLikeChannel = (channel: string | undefined): boolean =>
  channel === 'voice' || channel === 'web_call';
